import SegmentEventTypes from "./SegmentEventTypes";

declare let analytics: any;

const TrackWrap = (payload: SegmentEventTypes): void => {
  analytics.track(payload.name, { ...payload, name: undefined });
};

export default TrackWrap;
